import React, { Fragment, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Card, CardBlock, CardBody, FormGroup, Label } from "reactstrap";
import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import StateListClass from "../../../shared/components/state_list";
import { fetchStateList, getFacilityAuditCompletionAction } from "../../actions/actions";
import './react-date-picker.css';
import * as XLSX from "xlsx";
import './trackingReport.css';

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const AuditRegister = (props) => {
    const { dispatch, state_data, facility_audit_completion } = props;

    const [stateId, setStateId] = useState(null);
    const [year, setYear] = useState(new Date());
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({ date: false, state: false });
    const [fileName, setFileName] = useState('');

    const stateRef = useRef();
    const tableRef = useRef();

    useEffect(() => {
        var id = sessionStorage.getItem("role_id");
        dispatch(fetchStateList(id));
    }, []);

    const onStateChange = (event) => {
        let targetValue = event.target.value;
        setStateId(targetValue);
        setError((prev) => ({ ...prev, state: false }));
    };

    const onDateChange = (date) => {
        setYear(date);
        setError((prev) => ({ ...prev, date: false }));
    };

    const formatFileName = () => {
        let formattedState = 'All';
        if (stateId && state_data && state_data.length) {
            let stateObj = state_data.find(({ state_id }) => state_id == stateId);
            if (stateObj) {
                let splitState = stateObj.state_name.split(' ');
                formattedState = splitState.length === 1 ? splitState[0] : splitState.map((word) => word[0]).join('');
            }
        }
        setFileName(`${moment(year).format('yyyy')}_${formattedState}_Audit_Register.xlsx`);
    };

    const exportToExcel = () => {
        const wb = XLSX.utils.table_to_book(tableRef.current);
        XLSX.writeFile(wb, fileName);
    };

    const searchRecords = () => {
        if (!stateId) {
            setError((prev) => ({ ...prev, state: true }));
            return;
        }

        if (!year) {
            setError((prev) => ({ ...prev, date: true }));
            return;
        }

        setLoading(true);

        let params = {
            year: parseInt(moment(year).format('yyyy')),
            state_id: parseInt(stateId),
        };

        dispatch(getFacilityAuditCompletionAction(params)).then(() => {}).finally(() => {
            setLoading(false);
            formatFileName();
        });
    };

    // Group data by facility for monthly display
    const getGroupedData = () => {
        if (!Array.isArray(facility_audit_completion) || facility_audit_completion.length === 0) return [];

        const facilityMap = {};
        facility_audit_completion.forEach((item) => {
            if (!facilityMap[item.facility_id]) {
                facilityMap[item.facility_id] = {
                    facility_id: item.facility_id,
                    facility_name: item.facility_name,
                    months: {},
                };
            }
            facilityMap[item.facility_id].months[item.month] = item;
        });

        return Object.values(facilityMap).sort((a, b) => a.facility_name.localeCompare(b.facility_name));
    };

    const groupedData = getGroupedData();

    const ViewHeader = () => (
        <div className="view-header">
            <header className="title text-white">
                <h1 style={{ color: "white" }} className="h4 text-uppercase">
                    Audit Register
                </h1>
                <p className="mb-0">
                    View facility-wise monthly audit completion status.
                </p>
            </header>
        </div>
    );

    const FilterBox = () => {
        return (
            <div className="report_month_picker">
                <div className="row">
                    {/* Year */}
                    <div className="col-12 col-md-4">
                        <div className="rr_year_picker">
                            <FormGroup>
                                <Label>Year</Label>
                                <DatePicker
                                    className="form-control"
                                    selected={year}
                                    selectsStart
                                    withPortal
                                    value={year}
                                    maxDate={new Date()}
                                    dateFormat="yyyy"
                                    onChange={onDateChange}
                                    showYearPicker
                                />
                                <span className="error-text">
                                    {error.date ? "Please select a year" : null}
                                </span>
                            </FormGroup>
                        </div>
                    </div>

                    {/* State */}
                    <div className="col-12 col-md-4">
                        <FormGroup>
                            <Label>State</Label>
                            <StateListClass
                                ref={stateRef}
                                stateValue={stateId}
                                drpChangeState={onStateChange}
                                stateFillData={state_data}
                            />
                            <span className="error-text">
                                {error.state ? "Please select a state" : null}
                            </span>
                        </FormGroup>
                    </div>

                    {/* Submit BTN */}
                    <div className="col-12 col-md-4">
                        <button
                            className="btn btn-warning search_btn"
                            onClick={searchRecords}
                        >
                            {loading ? (
                                <div className="spinner-border spinner-border-sm text-light" role="status" />
                            ) : (
                                'Search'
                            )}
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="view">
            <ViewHeader />
            <div className="view-content view-components">
                <Card className="mb-4 comp-minHeight">
                    <CardBlock className="table-responsive">
                        <h6 className="mb-4 text-uppercase">Search</h6>
                        <FilterBox />
                    </CardBlock>
                </Card>

                {groupedData.length > 0 && (
                    <Card className="mb-4 col-md-12">
                        <CardBody className="table-responsive">
                            <div>
                                <div className="d-flex justify-content-between align-items-center mb-4 w-100">
                                    <h6 className="text-uppercase">Audit Completion Report</h6>
                                    <button className="btn btn-primary" onClick={() => exportToExcel()}>Export</button>
                                </div>
                                <div className="table_container">
                                    <table className="table" ref={tableRef}>
                                        <tbody>
                                            <tr className="text-center">
                                                <th className="text-center align-middle border">Facility Name</th>
                                                {MONTHS.map((month, index) => (
                                                    <th key={index} className="border">{month}</th>
                                                ))}
                                            </tr>
                                            {groupedData.map((facility) => (
                                                <tr key={facility.facility_id}>
                                                    <td className="border">{facility.facility_name}</td>
                                                    {MONTHS.map((_, monthIndex) => {
                                                        const monthData = facility.months[monthIndex + 1];
                                                        if (monthData) {
                                                            const pct = monthData.completion_percentage;
                                                            let pctClass = '';
                                                            if (pct >= 80) pctClass = 'color_green';
                                                            else if (pct >= 50) pctClass = 'color_yellow';
                                                            else if (pct > 0) pctClass = 'color_red';
                                                            return (
                                                                <td key={monthIndex} className={`text-center border ${pctClass}`}>{pct}%</td>
                                                            );
                                                        }
                                                        return (
                                                            <td key={monthIndex} className="text-center border">-</td>
                                                        );
                                                    })}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                )}
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    const { postsBySubreddit } = state;
    const { state_data, facility_audit_completion } = postsBySubreddit;
    return { state_data, facility_audit_completion };
}

const AuditRegisterContainer = connect(mapStateToProps)(AuditRegister);

export default AuditRegisterContainer;
